export default __webpack_public_path__ + "static/media/my-wheelbox-mobile.ed3456e3.png";